import useSWRMutationForm, { useErrorToSnackbar } from 'common-form/useSWRMutationForm';
import useApplication from '../../resources/applications/read';
import useRepairUpdate from '../../resources/repairs/update';

const useForm = () => {
  const {
    mutate: mutateApplication,
    isValidating: isValidatingApplication,
  } = useApplication();

  const onSubmit = (form) => ({
    repair: { actual_amount: form.financingAmount },
  });

  const {
    handleSubmit,
    isSubmitting,
    control,
    watch,
  } = useSWRMutationForm({
    useMutation: () => useRepairUpdate({ onSuccess: () => mutateApplication() }),
    onSubmit,
    useUnhandledError: useErrorToSnackbar,
  });

  const isLoading = isSubmitting || isValidatingApplication;

  return {
    isLoading,
    handleSubmit,
    control,
    watch,
  };
};

export default useForm;
